import { render, staticRenderFns } from "./AuthNotifications.vue?vue&type=template&id=6eb9a3b2&scoped=true&"
import script from "./AuthNotifications.vue?vue&type=script&lang=js&"
export * from "./AuthNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb9a3b2",
  null
  
)

export default component.exports